var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.xsOnly)?_c('collection-view-mobile',{attrs:{"collection-id":_vm.collectionId}}):_c('collection-view',{attrs:{"collection-id":_vm.collectionId}})}
var staticRenderFns = []

export { render, staticRenderFns }